// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-container {
    position: relative;
}
  
.select-options {
    padding: 0px;
    font-size: 16px;
    position: absolute;
    background-color: white;
    justify-content: center;
    align-items: center;
    z-index: 1;
    top: 102%;
    border-radius: 4px;
    border: 1px solid #E1E9EF;
    width: 100%;
    left: 0;
    overflow-y: scroll;
    height: auto;
    overflow-x: hidden;
    max-height: 155px;
}

.item-option {
    cursor: pointer;
    display: flex;
    padding: 1px 15px;
    width: 100%;
    height: 48px;
    font-weight: 800;
    color: #373D43;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    align-items: baseline;
}
  

.flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 5px;
}

.selected-option {
    margin: auto 0px;
    position: relative;
    height: 20px;
    width: 100%;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.falg-arrow {
    margin-left: 5px;
    transform: rotate(180deg);
}

.selected-option-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}


label.selected-option-label {
    color: #373D43 !important;
    font-size: 12px;
    font-weight: 400;
}

.selected-option-content.no-labrl {
    display: flex;
    justify-content: center;
    align-items: center;
}

.select-container.weight .select-options {
    width: 100%;
}


.select-container.weight .item-optio{
    justify-content: center;
}

.custom-input-container.withOutBorder.weight-input.backgroundWhite {
    border-left: 1px solid #E1E9EF !important;
    border-right: 1px solid #E1E9EF !important;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.weight .selected-option .falg-arrow {
    margin-left: 0px;
    margin-right: 16px;
}

.select-container.weight {
    width: 208px;
}

.custom-input-container.withOutBorder.weight-input {
    width: 100%;
}

.item-option.selected-item {
    background: #EDF4FD;
}

.item-option span {
    color: #6A696E;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
}

@media (max-width: 400x) {
    .custom-input-container.withOutBorder.weight-input {
        width: auto !important;
    }
}


`, "",{"version":3,"sources":["webpack://./src/components/CustomSelect/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".select-container {\n    position: relative;\n}\n  \n.select-options {\n    padding: 0px;\n    font-size: 16px;\n    position: absolute;\n    background-color: white;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    top: 102%;\n    border-radius: 4px;\n    border: 1px solid #E1E9EF;\n    width: 100%;\n    left: 0;\n    overflow-y: scroll;\n    height: auto;\n    overflow-x: hidden;\n    max-height: 155px;\n}\n\n.item-option {\n    cursor: pointer;\n    display: flex;\n    padding: 1px 15px;\n    width: 100%;\n    height: 48px;\n    font-weight: 800;\n    color: #373D43;\n    flex-direction: column;\n    justify-content: center;\n    font-size: 14px;\n    align-items: baseline;\n}\n  \n\n.flag-icon {\n    width: 24px;\n    height: 16px;\n    margin-right: 5px;\n}\n\n.selected-option {\n    margin: auto 0px;\n    position: relative;\n    height: 20px;\n    width: 100%;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.falg-arrow {\n    margin-left: 5px;\n    transform: rotate(180deg);\n}\n\n.selected-option-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n}\n\n\nlabel.selected-option-label {\n    color: #373D43 !important;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.selected-option-content.no-labrl {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.select-container.weight .select-options {\n    width: 100%;\n}\n\n\n.select-container.weight .item-optio{\n    justify-content: center;\n}\n\n.custom-input-container.withOutBorder.weight-input.backgroundWhite {\n    border-left: 1px solid #E1E9EF !important;\n    border-right: 1px solid #E1E9EF !important;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n}\n\n.weight .selected-option .falg-arrow {\n    margin-left: 0px;\n    margin-right: 16px;\n}\n\n.select-container.weight {\n    width: 208px;\n}\n\n.custom-input-container.withOutBorder.weight-input {\n    width: 100%;\n}\n\n.item-option.selected-item {\n    background: #EDF4FD;\n}\n\n.item-option span {\n    color: #6A696E;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n}\n\n@media (max-width: 400x) {\n    .custom-input-container.withOutBorder.weight-input {\n        width: auto !important;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
